import { Flex, Grid, InputNumber, Span } from "@goodfill/ui-components";
import { Controller, useFormContext } from "react-hook-form";
import { FieldGroup } from "../../../../../../form/FieldGroup";
import { CustomerApplicationFormState } from "../../../formState/formState";
import { KnowledgeLevelField } from "./KnowledgeLevelField";

export const Step6StockAndBondExperience = ({ areAllDisabled }: { areAllDisabled: boolean }) => {
  const { control } = useFormContext<CustomerApplicationFormState>();

  return (
    <Flex direction="col" horizontalPadding={8} verticalPadding={8} borderBottom="thin" items="center">
      <Span size="xl" uppercase={false} font="semibold">
        Stock & Bond Experience
      </Span>

      <Span className="Steps_welcomeMessage" wrap={true}>
        To open a free account and start you investing safely, we need to know more about you. Let's get started!
      </Span>

      <Grid cols={2} gap={0.75} className="w-full">
        <Controller
          render={({ field, fieldState: { error } }) => (
            <FieldGroup
              label="Bond Investment Experience"
              validation={error?.message ? [error.message] : []}
              className="w-80-sm w-full-after-md"
              fill
            >
              <InputNumber
                placeholder="Enter years of bond experience"
                value={field.value}
                setValue={field.onChange}
                border={error === undefined ? "neutral" : "red"}
                onBlur={field.onBlur}
                ref={field.ref}
                id="yearsExperienceBonds"
              />
            </FieldGroup>
          )}
          name="step6.yearsExperienceBonds"
          control={control}
        />

        <Controller
          render={({ field, fieldState: { error } }) => (
            <FieldGroup
              label="Bond Trades per Year"
              validation={error?.message ? [error.message] : []}
              className="w-80-sm w-full-after-md"
              fill
            >
              <InputNumber
                placeholder="Enter no. of yearly trade average"
                value={field.value}
                setValue={field.onChange}
                border={error === undefined ? "neutral" : "red"}
                onBlur={field.onBlur}
                ref={field.ref}
                id="tradesPerYearBonds"
              />
            </FieldGroup>
          )}
          name="step6.tradesPerYearBonds"
          control={control}
        />
      </Grid>
      <Flex className="w-full">
        <Controller
          render={({ field, fieldState: { error } }) => (
            <KnowledgeLevelField
              id="bondsExperienceLevel"
              title="Bonds Knowledge level"
              onSelect={field.onChange}
              selected={field.value}
              validation={error?.message ? [error.message] : []}
              onBlur={field.onBlur}
              ref={field.ref}
            />
          )}
          name="step6.bondsExperienceLevel"
          control={control}
        />
      </Flex>
    </Flex>
  );
};
